"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _conductor = require("@virtuous/conductor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function Reset(_ref) {
  var children = _ref.children,
      className = _ref.className,
      state = _ref.state;

  var _stack$first = _conductor.stack.first(),
      _stack$first2 = _slicedToArray(_stack$first, 2),
      route = _stack$first2[1];

  function handleClick(event) {
    event.preventDefault();

    _conductor.router.reset(state);
  }

  return _react["default"].createElement("a", {
    className: className,
    href: route.location,
    onClick: handleClick
  }, children);
}

Reset.defaultProps = {
  className: null,
  state: null
};

var _default = _react["default"].memo(Reset);

exports["default"] = _default;